import React, { useState, useEffect } from 'react'
import { Card, CardBody, Row, Col, FormGroup, Label, Button, Alert } from 'reactstrap'
import { ToastNotification } from '../Lessons/CourseReport/CourseReportComponents'
import { useNavigate } from 'react-router-dom'
import { deleteIdData, addData } from '../../lib/sessionschedule'
import { getInstructorIdData as getInstructorDataforStudents } from '../../lib/sessionscheduleview'
import { getDataforInstructorActiveStudent } from '../../lib/classdetailview'
import { useAuth } from '../../_helper/Auth/AuthProvider'
import { getCurrentDateInput, getCurrentTimeInput } from '../../utils/dateTimeUtils'
import moment from 'moment'
import { useLayout } from '../../Hooks/useLayout'
import { useParams } from 'react-router-dom'

const InstructorScheduleAdd = () => {
	const { studentId } = useParams()
	const [instructorId, setInstructorId] = useState('')
	const [instructorStudent, setInstructorStudent] = useState([])
	const [selectedStudent, setSelectedStudent] = useState('')
	const [instructorSchedule, setInstructorSchedule] = useState([])
	const [selectedClass, setSelectedClass] = useState('')
	const [period, setPeriod] = useState('OneDate')
	const [startDate, setStartDate] = useState('')
	const [endDate, setEndDate] = useState('')
	const [time, setTime] = useState('')
	const [showEndDate, setShowEndDate] = useState(false)
	const [error, setError] = useState('')
	const [loading, setLoading] = useState(false)
	const [initialLoading, setInitialLoading] = useState(true)
	const [isDarkMode, setIsDarkMode] = useState(false)
	const [toastMessage, setToastMessage] = useState('')
	const [showToast, setShowToast] = useState(false)

	const showToastMessage = (message) => {
		setToastMessage(message)
		setShowToast(true)
		setTimeout(() => setShowToast(false), 3000)
	}

	const { user } = useAuth()
	const navigate = useNavigate()
	const layout = useLayout()

	const handleDelete = async (id) => {
		const choice = window.confirm('Are You Sure?')
		if (choice) {
			try {
				await deleteIdData(id)
				showToastMessage('Schedule deleted successfully!')
				getInstructorScheduleData()
			} catch (error) {
				console.error('Error deleting schedule:', error)
				setError('Failed to delete schedule')
			}
		}
	}

	const getInstructorStudent = async () => {
		if (!user?.id) {
			setInitialLoading(false)
			return
		}

		try {
			setInitialLoading(true)
			const students = await getDataforInstructorActiveStudent(user.id)
			if (students && students.length > 0) {
				setInstructorStudent(students)
				setInstructorId(user.id)

				if (studentId) {
					setSelectedStudent(studentId)
				} else {
					setSelectedStudent(students[0].studentId)
				}

				setSelectedClass(students[0].classId)
			}
		} catch (error) {
			console.error('Error fetching instructor students:', error)
			setError('Failed to load students')
		} finally {
			setInitialLoading(false)
		}
	}

	const getInstructorScheduleData = async () => {
		if (!user?.id || !selectedStudent) return

		try {
			const sched = await getInstructorDataforStudents(user.id, selectedStudent)
			setInstructorSchedule(sched)
		} catch (error) {
			console.error('Error fetching instructor schedule data:', error)
			setError('Failed to load schedule data')
		}
	}

	const getDateRange = () => {
		let addday = 0
		let jstr = 'days'

		if (period === 'EveryWeek') addday = 7
		if (period === 'EveryOtherWeek') addday = 14
		if (period === 'EveryMonth') {
			addday = 1
			jstr = 'months'
		}

		const dateArray = []
		let currentDate = startDate
		while (currentDate <= endDate) {
			dateArray.push(currentDate)
			currentDate = moment(currentDate).add(addday, jstr).format('YYYY-MM-DD')
		}
		return dateArray
	}

	const handleSubmit = async (e) => {
		e.preventDefault()
		setLoading(true)
		setError('')

		try {
			const recArray = []

			if (period === 'OneDate') {
				recArray.push({
					studentId: selectedStudent,
					classId: selectedClass,
					instructorId: instructorId,
					ldate: startDate,
					ltime: time
				})
			} else {
				const dateArray = getDateRange()

				dateArray.forEach((data) => {
					recArray.push({
						studentId: selectedStudent,
						classId: selectedClass,
						instructorId: instructorId,
						ldate: data,
						ltime: time
					})
				})
			}

			await addData(recArray)
			getInstructorScheduleData()
			showToastMessage('Schedule added successfully!')
			setTimeout(() => {
				if (studentId) {
					navigate(`${process.env.PUBLIC_URL}/instructor/student-schedule/${studentId}/${layout}`)
				} else {
					navigate(`${process.env.PUBLIC_URL}/instructor/schedules/${layout}`)
				}
			}, 2000)
		} catch (error) {
			console.error('Error adding schedule:', error)
			setError('Failed to add schedule')
		} finally {
			setLoading(false)
		}
	}

	useEffect(() => {
		if (period !== 'OneDate') {
			setShowEndDate(true)
		} else {
			setShowEndDate(false)
		}
	}, [period])

	useEffect(() => {
		if (instructorStudent.length > 0) {
			const student = instructorStudent.find((std) => std.studentId === selectedStudent)
			if (student) {
				setSelectedClass(student.classId)
			}
		}
		getInstructorScheduleData()
	}, [selectedStudent])

	useEffect(() => {
		setStartDate(getCurrentDateInput())
		setEndDate(getCurrentDateInput(7))
		setTime(getCurrentTimeInput())

		if (user?.id) {
			getInstructorStudent()
		}
	}, [user?.id])

	useEffect(() => {
		if (user?.id && selectedStudent) {
			getInstructorScheduleData()
		}
	}, [user?.id, selectedStudent])

	useEffect(() => {
		const checkDarkMode = () => {
			setIsDarkMode(document.body.classList.contains('dark-only'))
		}
		checkDarkMode()
		const observer = new MutationObserver(checkDarkMode)
		observer.observe(document.body, { attributes: true, attributeFilter: ['class'] })
		return () => observer.disconnect()
	}, [])

	if (initialLoading) {
		return (
			<Card style={{ backgroundColor: isDarkMode ? '#2a2d35' : '#fff' }}>
				<CardBody style={{ backgroundColor: isDarkMode ? '#2a2d35' : '#fff' }}>
					<div className="text-center">
						<div className="spinner-border" role="status">
							<span className="visually-hidden">Loading...</span>
						</div>
						<p className="mt-2" style={{ color: isDarkMode ? '#fff' : 'inherit' }}>Loading schedule data...</p>
					</div>
				</CardBody>
			</Card>
		)
	}

	return (
		<Card style={{ backgroundColor: isDarkMode ? '#2a2d35' : '#fff' }}>
			<ToastNotification show={showToast} message={toastMessage} onClose={() => setShowToast(false)} />
			<CardBody style={{ backgroundColor: isDarkMode ? '#2a2d35' : '#fff' }}>
				<div className="personal-info-head mb-2">
					<h4 style={{ color: isDarkMode ? '#fff' : 'inherit' }}>Instructor Schedule</h4>
					<p></p>
				</div>

				{error && (
					<Alert color="danger" className="alert-dismissible fade show" role="alert">
						<strong>Error:</strong> {error}
						<Button type="button" className="btn-close" onClick={() => setError('')} aria-label="Close"></Button>
					</Alert>
				)}

				<form onSubmit={handleSubmit}>
					<Row>
						<Col lg="3">
							<FormGroup>
								<Label className="form-control-label" style={{ color: isDarkMode ? '#fff' : 'inherit' }}>Student</Label>
								<select
									value={selectedStudent}
									onChange={(e) => setSelectedStudent(e.target.value)}
									className="form-control"
									required
									style={{
										backgroundColor: isDarkMode ? '#2a2d35' : '#fff',
										color: isDarkMode ? '#fff' : 'inherit'
									}}
								>
									{instructorStudent.map((data, ix) => (
										<option key={ix} value={data.studentId}>
											{data.studentName + ' ' + data.studentSurname}
										</option>
									))}
								</select>
							</FormGroup>
						</Col>
						<Col lg="3">
							<FormGroup>
								<Row>
									<Col xs="6">
										<Label className="form-control-label" style={{ color: isDarkMode ? '#fff' : 'inherit' }}>Date</Label>
										<input
											type="date"
											value={startDate}
											onChange={(e) => setStartDate(e.target.value)}
											className="form-control"
											required
											style={{
												backgroundColor: isDarkMode ? '#2a2d35' : '#fff',
												color: isDarkMode ? '#fff' : 'inherit'
											}}
										/>
									</Col>
									<Col xs="6">
										<Label className="form-control-label" style={{ color: isDarkMode ? '#fff' : 'inherit' }}>Time</Label>
										<input
											type="time"
											value={time}
											onChange={(e) => setTime(e.target.value)}
											className="form-control"
											required
											style={{
												backgroundColor: isDarkMode ? '#2a2d35' : '#fff',
												color: isDarkMode ? '#fff' : 'inherit'
											}}
										/>
									</Col>
								</Row>
							</FormGroup>
						</Col>
						<Col lg="3">
							<FormGroup>
								<Label className="form-control-label" style={{ color: isDarkMode ? '#fff' : 'inherit' }}>Period</Label>
								<select
									value={period}
									onChange={(e) => setPeriod(e.target.value)}
									className="form-control"
									style={{
										backgroundColor: isDarkMode ? '#2a2d35' : '#fff',
										color: isDarkMode ? '#fff' : 'inherit'
									}}
								>
									<option value="OneDate">One Date</option>
									<option value="EveryWeek">Every Week</option>
									<option value="EveryOtherWeek">Every Other Week</option>
									<option value="EveryMonth">Every Month</option>
								</select>
							</FormGroup>
						</Col>
						{showEndDate && (
							<Col lg="3">
								<FormGroup>
									<Label className="form-control-label" style={{ color: isDarkMode ? '#fff' : 'inherit' }}>End Date</Label>
									<input
										type="date"
										value={endDate}
										onChange={(e) => setEndDate(e.target.value)}
										className="form-control"
										required
										style={{
											backgroundColor: isDarkMode ? '#2a2d35' : '#fff',
											color: isDarkMode ? '#fff' : 'inherit'
										}}
									/>
								</FormGroup>
							</Col>
						)}
					</Row>
					<div className="update-profile d-flex justify-content-end">
						<Button type="submit" className="btn btn-primary" disabled={loading}>
							{loading ? 'Adding...' : 'Add New Date'}
						</Button>
					</div>
				</form>

				<hr className="mt-2" />
				<div className="comman-space pb-0">
					<div className="settings-referral-blk course-instruct-blk table-responsive">
						<table className="table table-nowrap mb-0" style={{ backgroundColor: isDarkMode ? '#2a2d35' : '#fff', color: isDarkMode ? '#fff' : 'inherit' }}>
							<thead>
								<tr>
									<th style={{ color: isDarkMode ? '#fff' : 'inherit' }}>ID</th>
									<th style={{ color: isDarkMode ? '#fff' : 'inherit' }}>Class</th>
									<th style={{ color: isDarkMode ? '#fff' : 'inherit' }}>Date</th>
									<th style={{ color: isDarkMode ? '#fff' : 'inherit' }}>Time</th>
									<th style={{ color: isDarkMode ? '#fff' : 'inherit' }}>Delete</th>
								</tr>
							</thead>
							<tbody>
								{instructorSchedule && instructorSchedule.length > 0
									? instructorSchedule.map((data) => (
											<tr key={data.id} style={{ backgroundColor: isDarkMode ? '#2a2d35' : '#fff' }}>
												<td style={{ color: isDarkMode ? '#fff' : 'inherit' }}>{data.id}</td>
												<td style={{ color: isDarkMode ? '#fff' : 'inherit' }}>{data.studentname}</td>
												<td style={{ color: isDarkMode ? '#fff' : 'inherit' }}>{data.ldate}</td>
												<td style={{ color: isDarkMode ? '#fff' : 'inherit' }}>{data.ltime.substring(0, 5)}</td>
												<td>
													<div className="profile-share">
														<Button className="btn btn-danger btn-sm" onClick={() => handleDelete(data.id)}>
															Delete
														</Button>
													</div>
												</td>
											</tr>
									  ))
									: ''}
							</tbody>
						</table>
					</div>
				</div>
			</CardBody>
		</Card>
	)
}

export { InstructorScheduleAdd }
